
const React = require('react')
const agents = require('./agents')
const login = require('./login')
const store = require('../')
const splitTests = require('./splitTests')

const connects = {
  agents,
  login,
  splitTests
}

const callback = (Component, types) => {
  if (!types) return Component
  if (!Component) return
  if (types.constructor !== Array) types = [types]
  let name = 'Component'
  types.map((type, i) => {
    Component = connects[type](Component)
    if (Component.displayName) name = Component.displayName.replace(/Connect\(/g, '').replace(/\)/g, '')
  })
  const App = class App extends React.PureComponent {
    render () {
      return (
        <Component {...this.props} store={store} />
      )
    }
  }
  try {
    Object.defineProperty(App, 'name', {value: `${name}Wrapper`})
  } catch (e) {
    // console.log('Can not change readonly property bug')
  }
  return App
}

module.exports = callback
